import { FloppyDisk, Trash, X } from "@phosphor-icons/react";

const UnsavedChangesModal = ({ open, onConfirm, title = "Unsaved changes", subtitle = "You have edits that haven't been saved." }) => {
  if (!open) return null;
  return (
    <div className="fixed inset-0 bg-slate-900/70 backdrop-blur-sm z-[100] flex items-center justify-center p-4" role="dialog" aria-modal="true">
      <div className="bg-white shadow-2xl w-full max-w-md border-t-4 border-amber-500" data-testid="unsaved-changes-modal">
        <div className="px-6 py-5 border-b border-slate-200">
          <h3 className="text-lg font-bold" style={{ fontFamily: "Outfit, sans-serif" }}>{title}</h3>
          <p className="text-sm text-slate-500 mt-1">{subtitle}</p>
        </div>
        <div className="p-6 space-y-2">
          <button
            data-testid="unsaved-save-draft-btn"
            onClick={() => onConfirm("save")}
            className="w-full flex items-center justify-between px-4 py-3 bg-amber-50 hover:bg-amber-100 border border-amber-200 text-amber-900 font-medium transition group"
          >
            <span className="flex items-center gap-3"><FloppyDisk size={18} weight="fill" /> Save as draft & continue</span>
            <span className="text-xs uppercase tracking-[0.2em] text-amber-600 group-hover:text-amber-800">Recommended</span>
          </button>
          <button
            data-testid="unsaved-discard-btn"
            onClick={() => onConfirm("discard")}
            className="w-full flex items-center gap-3 px-4 py-3 bg-slate-50 hover:bg-red-50 border border-slate-200 hover:border-red-200 text-slate-700 hover:text-red-700 font-medium transition"
          >
            <Trash size={18} /> Discard changes
          </button>
          <button
            data-testid="unsaved-stay-btn"
            onClick={() => onConfirm("stay")}
            className="w-full flex items-center gap-3 px-4 py-3 hover:bg-slate-50 text-slate-600 font-medium transition"
          >
            <X size={18} /> Stay on this page
          </button>
        </div>
      </div>
    </div>
  );
};

export default UnsavedChangesModal;
